import { forwardRef } from 'react';
import { Chip, darken, lighten } from '@mui/material';

type CustomChipProps = {
  label: string;
  size: 'small' | 'medium' | undefined;
  color: 'success' | 'warning' | 'error' | 'info' | 'grey';
  smallRadius?: boolean;
};

export const CustomChip = forwardRef<HTMLDivElement, CustomChipProps>((props, ref) => {
  const { label, size, color, smallRadius, ...other } = props;

  const radiusSx = smallRadius ? { borderRadius: 1 } : undefined;

  return (
    <>
      {color === 'success' && (
        <Chip
          ref={ref}
          label={label}
          sx={{
            backgroundColor: (thm) => lighten(thm.palette.success.main, 0.8),
            color: (thm) => darken(thm.palette.success.main, 0.5),
            fontSize: (thm) => thm.typography.caption.fontSize,
            fontWeight: (thm) => thm.typography.fontWeightMedium,
            ...radiusSx,
          }}
          size={size}
          {...other}
        />
      )}
      {color === 'error' && (
        <Chip
          ref={ref}
          label={label}
          sx={{
            backgroundColor: (thm) => lighten(thm.palette.error.main, 0.8),
            color: (thm) => darken(thm.palette.error.main, 0.5),
            fontSize: (thm) => thm.typography.caption.fontSize,
            fontWeight: (thm) => thm.typography.fontWeightMedium,
            ...radiusSx,
          }}
          size={size}
          {...other}
        />
      )}
      {color === 'warning' && (
        <Chip
          ref={ref}
          label={label}
          sx={{
            backgroundColor: (thm) => lighten(thm.palette.warning.main, 0.8),
            color: (thm) => darken(thm.palette.warning.main, 0.5),
            fontSize: (thm) => thm.typography.caption.fontSize,
            fontWeight: (thm) => thm.typography.fontWeightMedium,
            ...radiusSx,
          }}
          size={size}
          {...other}
        />
      )}
      {color === 'info' && (
        <Chip
          ref={ref}
          label={label}
          sx={{
            backgroundColor: (thm) => lighten(thm.palette.info.main, 0.8),
            color: (thm) => darken(thm.palette.info.main, 0.5),
            fontSize: (thm) => thm.typography.caption.fontSize,
            fontWeight: (thm) => thm.typography.fontWeightMedium,
            ...radiusSx,
          }}
          size={size}
          {...other}
        />
      )}
      {color === 'grey' && (
        <Chip
          ref={ref}
          label={label}
          sx={{
            backgroundColor: (theme) => theme.palette.grey[300],
            color: (theme) => theme.palette.grey[900],
            fontSize: (thm) => thm.typography.caption.fontSize,
            fontWeight: (thm) => thm.typography.fontWeightMedium,
            ...radiusSx,
          }}
          size={size}
          {...other}
        />
      )}
    </>
  );
});
